import styled from "@emotion/styled";
import './Loader.css'

export const Loader = () => (<div className="lds-spinner">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
</div>)


export const LoaderWrapper = styled.div`
  background-color: #181f4c;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`